export const UPDATE_ROUTE_TIMER = "update_route_timer";

export const GET_ROUTES = "get_routes";
export const REFRESH_ROUTES = "refresh_routes";
export const LOAD_MORE_ROUTES = "load_more_routes";
export const GET_ROUTES_FAIL = "get_routes_fail";
export const GET_ROUTES_SUCCESS = "get_routes_success";
export const LOAD_MORE_ROUTES_SUCCESS = "load_more_routes_success";

export const TOGGLE_SHOW_ROUTES = "toggle_show_routes";
export const ACKNOWLEDGE_END_ROUTE = "acknowledege_end_route";

export const START_TRACKED_ROUTE = "start_tracked_route";
export const START_TRACKED_ROUTE_SUCCESS = "start_tracked_route_success";
export const START_TRACKED_ROUTE_FAIL = "start_tracked_route_fail";

export const START_PLANNED_ROUTE = "start_planned_route";
export const START_PLANNED_ROUTE_SUCCESS = "start_planned_route_success";
export const START_PLANNED_ROUTE_FAIL = "start_planned_route_fail";

export const END_PLANNED_ROUTE = "end_planned_route";
export const END_PLANNED_ROUTE_SUCCESS = "end_planned_route_success";
export const END_PLANNED_ROUTE_FAIL = "end_planned_route_fail";
export const PREPPED_PLANNED_ROUTE = "prepped_planned_route";
export const UPDATE_PLANNED_ROUTE = "update_planned_route";
export const UPDATE_PLANNED_ROUTE_SUCCESS = "update_planned_route_success";
export const UPDATE_PLANNED_ROUTE_FAIL = "update_planned_route_fail";

export const CLEAR_ROUTES = "clear_routes";
export const UPDATE_TRACKED_ROUTE = "update_tracked_route";
export const UPDATE_TRACKED_ROUTE_SUCCESS = "update_tracked_route_success";
export const UPDATE_TRACKED_ROUTE_FAIL = "update_tracked_route_fail";

export const UPDATE_CURRENT_ROUTE_SECTION = "update_current_route_section";

export const END_TRACKED_ROUTE = "end_tracked_route";
export const END_TRACKED_ROUTE_SUCCESS = "end_tracked_route_success";
export const END_TRACKED_ROUTE_FAIL = "end_tracked_route_fail";

export const REMOVE_TRACKED_ROUTE = "remove_tracked_route";
export const REMOVE_TRACKED_ROUTE_FAIL = "remove_tracked_route_fail";
export const REMOVE_TRACKED_ROUTE_SUCCESS = "remove_tracked_route_success";
export const INIT_EDIT_ROUTE_FILTERS = "init_edit_route_filters";
export const UPDATE_ROUTE_FILTER = "update_route_filter";
export const UPDATE_SINGLE_ROUTE_FILTER = "update_single_route_filter";
export const EDIT_ROUTE_FILTER = "edit_route_filter";
export const SAVE_ROUTE_FILTERS = "save_route_filters";

export const SELECT_ACTIVE_ROUTE = "select_active_route";
export const GET_ROUTE_PROPERTIES = "get_route_properties";
export const REFRESH_ROUTE_PROPERTIES = "refresh_route_properties";
export const GET_ROUTE_PROPERTIES_FAIL = "get_route_properties_fail";
export const GET_ROUTE_PROPERTIES_SUCCESS = "get_route_properties_success";
export const MAP_ROUTES_SUCCESS = "map_routes_success";
export const TRIGGER_PLANNED_ROUTE = "trigger_planned_route";
export const ROUTE_PROPERTIES_TOGGLE_TAB = "route_properties_toggle_tab";

export const TOGGLE_DRIVING_IMAGES = "toggle_driving_images";

export const GET_PROPERTY_WITH_ROUTE_INFO = "get_property_with_route_info";
export const GET_PROPERTY_WITH_ROUTE_INFO_FAIL =
  "get_property_with_route_info_fail";
export const GET_PROPERTY_WITH_ROUTE_INFO_SUCCESS =
  "get_property_with_route_info_success";

export const SET_PLANNED_ROUTE = "set_planned_route";
export const TOGGLE_DRIVING_MENU = "toggle_driving_menu";
export const SET_ROUTE_PLANNED_DISTANCE = "set_route_planned_distance";

export const RESTORE_CURRENT_ROUTE_SUCCESS = "restore_current_route_success";
export const TOGGLE_VIRTUAL_DRIVE_START = "toggle_virtual_drive_start";
